const resolve = store => (to, from, next) => {
    // We are checking all the matched routes for nested routes, so that the parent view is properly
    // populated with data (mostly in case of nested modal views)
    //
    // (cf. https://router.vuejs.org/api/#route-object-properties)
    //
    if (to.matched.some(record => record.meta && Array.isArray(record.meta.resolvers))) {
        // Start progress bar
        store.dispatch("api/progress/start");

        const resolvers = to.matched
            // 1. As we can have nested routes, we might have an array of matched routes, and we want to call
            // all the resolvers of all matched routes
            .map(record =>
                (record.meta.resolvers || [])
                    // 2. Some resolvers are conditional, so they will only yield an action if some conditions are met
                    .map(resolver => resolver(to, from))
                    // 3. Filter `null` and `undefined` actions
                    .filter(Boolean)
                    // 4. Dispatch actions
                    .map(action => store.dispatch(action)),
            )
            // 5. Flatten the array to be able to await for all the promises in a Promise.all() call.
            .flat();

        // Dispatch all the actions
        //
        // Note: we are returning the Promise for testing purposes.
        //
        return Promise.all(resolvers)
            .then(() => {
                // All good, navigate to the next screen
                store.dispatch("api/progress/finish");
                next();
            })
            .catch(err => {
                if (process.env.NODE_ENV !== "production") {
                    // eslint-disable-next-line no-console
                    console.log(err);
                }

                store.dispatch("api/progress/finish");

                if (from.name) {
                    // Stay on the same screen
                    next(false);
                } else {
                    // Redirect to profile
                    next("/profile");
                }
            });
    } else {
        next();
    }
};

export default resolve;
